function triggerClock() {
  const minHand  = document.querySelector('.js-sk-clock-min');
  const hourHand = document.querySelector('.js-sk-clock-hour');

  function setDate() {
    const now = new Date();

    //let hours = now.getUTCHours() + 1;
    let hours = new Date().toLocaleTimeString('fr-CH', { timeZone: 'Europe/Zurich' }).slice(0, 2);

    if (hours >= 24) {
      hours -= 24;
    }
    const minutes = now.getUTCMinutes();

    const minutesDegrees = ((minutes / 60) * 360) + 90;
    minHand.style.transform = `rotate(${minutesDegrees}deg)`;

    const hoursDegrees = ((hours / 12) * 360) + ((minutes/60)*30) + 90;
    hourHand.style.transform = `rotate(${hoursDegrees}deg)`;
  }

  if (minHand && hourHand) {
    setInterval(setDate, 60000);
    setDate();
  }
}

export {
  triggerClock,
}
